export enum GridWidthType {
  DesktopStandard = '1180px',
  DesktopWide = '1200px',
}
